/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { string, node, object } from 'prop-types';

const LinkOrATag = ({
    href, id, children, style, name, className, key, dataTest,
}) => {
    if (href?.includes('/blog')  || href?.includes('www')  || href?.indexOf('http://') === 0 || href?.indexOf('https://') === 0)  {
        return <a style={style} className={className} id={id} href={href} name={name} key={key} data-test={dataTest}>{children}</a>;
    }
    return <Link style={style} to={href} id={id} className={className} name={name} key={key} data-test={dataTest}>{children}</Link>;
};

LinkOrATag.propTypes = {
    href: string.isRequired,
    id: string,
    children: node.isRequired,
    style: object,
    name: string,
    className: string,
    key: string,
    dataTest: string,
};

LinkOrATag.defaultProps = {
    id: '',
    style: {},
    name: '',
    className: '',
    key: '',
    dataTest: '',
};

export default LinkOrATag;
